import { createEffect, onCleanup } from 'solid-js';
import { correctElementType, type CorrectComponentType } from '@brytdesigns/web-component-core/utils';

import { useFaq } from './faq-search-context';
import { formatTemplate, getCategoryLabel } from './faq-search-text';

export const FaqEmpty: CorrectComponentType<Record<string, never>> = (_props, { element }) => {
  const [state, actions] = useFaq(element);
  const messageEl = element.querySelector<HTMLElement>('[data-empty-message]');
  const buttonEl = element.querySelector<HTMLButtonElement>('button');

  actions.registerEmpty(element);

  createEffect(() => {
    const query = state.query();
    const ac = state.activeCategory();
    const total = state.visibleTotal();
    const isEmpty = !!query && total === 0;
    if (!isEmpty || !messageEl || !buttonEl) return;

    const tpl =
      ac === 'all' ? (element.dataset.localeNoResultsGlobal ?? '') : (element.dataset.localeNoResultsInCategory ?? '');
    messageEl.textContent = formatTemplate(tpl, { query, category: getCategoryLabel(ac) });
    buttonEl.textContent =
      ac === 'all'
        ? (element.dataset.localeClearSearch ?? 'Clear search')
        : (element.dataset.localeSearchAll ?? 'Search all FAQs');
  });

  const onClick = () => {
    if (state.activeCategory() !== 'all') actions.setActiveCategory('all');
    else actions.flushQuery('');
  };
  element.addEventListener('click', onClick);
  onCleanup(() => element.removeEventListener('click', onClick));
};

export const FaqEmptyComponent = correctElementType(FaqEmpty);
